<template>
<div>
  <v-container fluid class="mb-5">
    <v-row justify="space-between">
      <v-col cols="12" class="text-left d-flex align-center">
          <v-btn v-if="is_admin" color="mygreen" dark to="/staff" class="mr-4">
              <v-icon class="mr-2">mdi-plus</v-icon>
              スタッフ登録</v-btn>
      </v-col>
    </v-row>
  </v-container>


  <v-data-table
    fixed-header
    :headers="headers"
    :items="records"
    :items-per-page="20"
    sort-by="calories"
    class="elevation-1"
    :height="tableHeight"
    v-resize="onResize"
    @click:row="rowClick"
  >

    <template v-slot:item.name="{ item }">
        <div v-html="item.name"></div>
    </template>
    <template v-slot:item.yuukyuu="{ item }">
        <div>{{item.yuukyuu}}日</div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-btn v-if="is_access(item)"
        @click.stop.prevent="yuukyuu(item)"
        :class="{'mr-4': true}"
        color="">
        有休管理
      </v-btn>
    </template>


    <template v-slot:no-data>
    データがありません.
    </template>


  </v-data-table>


</div>



</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
/* eslint-disable */


  export default {
    data(){  // datas
        return {
          date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          menu1: false,
          menu2: false,
          modal: false,


          title: '',
          tableHeight: 700,
          dialog: false,
          dialogDelete: false,
          headers: [
            {
              text: 'ID', align: 'start', value: 'staff_str_id',
              width: '8%',
            },
            {
              text: 'スタッフ名',
              align: 'start',
              value: 'name',
              width: '12%',
            },
            { text: '固定電話番号', value: 'tel', width: '12%' },
            { text: '携帯電話番号', value: 'phone', width: '12%' },
            { text: 'メールアドレス', value: 'mail', width: '10%' },
            { text: '職種', value: 'job', width: '10%'  },
            { text: '権限', value: 'auth', width: '10%' },
            { text: '入社年月日', value: 'hire_date', width: '12%'  },
            { text: '残り有休', value: 'yuukyuu', width: '6%' },
            { text: '', value: 'actions', sortable: false, width: '4%'},  // v-slot:item.actions と紐付いている
          ],
          records: [],
          editedIndex: -1,
          editedItem: {
            name: '',
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0,
          },
          defaultItem: {
            name: '',
            calories: 0,
            fat: 0,
            carbs: 0,
            protein: 0,
          },
        }
    },


    computed: {
      ...mapGetters(['user', 'user_name', 'is_admin']),
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
        console.log('%ccreated: StaffListView.vue', mycolor.purple);
        this.initialize()
//        this.onResize();  // これ必要か?
    },

    methods: {
        is_access(item){
            // 有休管理ボタンの出現フラグ
            let staff_id = item.id;
            if( !this.is_admin && (staff_id!=this.user.id) ){
                return false;
            }
            return true;
        },
        yuukyuu(item){
            // 有休管理ボタン押下
            console.log(item);
            this.$router.push( '/yuukyuu/'+item.id ).catch(()=>{});
        },

        rowClick(v){
            console.log('rowClick');
            console.log(v);


            if( !this.is_admin && (this.user.id!==v.id) ){
                // 一般スタッフは閲覧禁止
                alert('閲覧できません');
                return false;
            }

            this.$router.push('/staff/'+v.id ).catch(()=>{});
        },

      onResize() {
        console.log('onResize');
        console.log(this);
        this.tableHeight = window.innerHeight - 300;
      },


      // 初期化 todo:
      initialize () {
        console.log('initialize');
        axios.get('/get_staffs')
          .then((res) => {
                console.group();
                console.log('%c /get_staffs', mycolor.api);
                console.log(res.data);
                console.groupEnd();

                this.records = res.data.filter( v => {
                    return v.id!=0;
                });
          })
          .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
          });
      },


/*
          {
            date_come: '2022/04/01 09:00～10:30',
            bangou: 1,
            patient: 'A',
            tantou: '田中',
            unit: 'UNIT 1',
            monshin_status: true,
            syochi_status: false,
            memo_status: false,
          },
*/




      deleteItem (item) {
        console.log(item);
        this.editedIndex = this.records.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.records.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.records[this.editedIndex], this.editedItem)
        } else {
          this.records.push(this.editedItem)
        }
        this.close()
      },
    },  // methods

  }
</script>

<style scoped>
/deep/ .kana{
    font-size: 9px;
}
/deep/ button.v-btn.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default:hover {
    background-color: rgba(0, 189, 242, 1) !important;
    border-color: rgba(0, 189, 242, 1) !important;
    color: white;
}
</style>
